const getDomain = () => {
    const currentPath = window.location.pathname;
    return currentPath.split('/')[1];
};

export default getDomain;
